import React, { useState, useEffect } from "react";
import { setKey, fromAddress, setLanguage, setRegion } from "react-geocode";

const GOOGLE_MAPS_KEY = import.meta.env.VITE_GOOGLE_MAPS;

export default function useGeocode(props) {
  const [error, setError] = useState(false);
  const [coordinates, setCoordinates] = useState(null);
  const { street, state, city, neighborhood } = props;
  setKey(GOOGLE_MAPS_KEY);
  setLanguage("es");
  setRegion("mx");

  useEffect(() => {
    if (street && state && city && neighborhood) {
      fromAddress(`${street}, ${neighborhood}, ${city}, ${state}`).then(
        (response) => {
          setCoordinates(response.results[0].geometry.location);
        },
        (error) => {
          setError(error);
        },
      );
    }
  }, [street, state, city, neighborhood]);

  return { error, coordinates };
}
